import HeaderBackground from "./HeaderBackground";
import background from './img/BANNER.png';

function NotFound() {
    return <div style={{textAlign: "center"}}>
        <HeaderBackground background={background} title="Nicht Gefunden" />
        <h1>
            404 - Nicht gefunden
        </h1>
    </div>
}

export default NotFound;